let currentYear = null;

export const setCurrentYear = (year) => {
    currentYear = year;
};

const getCurrentYear = () => currentYear;

export default getCurrentYear;
